import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss']
})
export class MessageModalComponent implements OnInit {
  @Input() public title: string;
  @Input() public buttonText: String = 'Ja, löschen';
  productForm: any;

  constructor(
    public modal: NgbActiveModal,
    public translate: TranslateService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.buildProductForm();
  }

  buildProductForm(): void {
    this.productForm = this.fb.group({
      message: ['', Validators.required]
    });
  }

  onConfirm(): void {
    if (this.productForm.valid) {
      this.modal.close({
        success: true,
        data: this.productForm.value
      });
    } else {
      this.snackBar.open(this.translate.instant('common.isRequired'), 'Close', { duration: 2000 });
    }
  }

  onCancel(): void {
    this.modal.dismiss({
      success: false,
      data: null
    });
  }
}
